import { Api } from "@/plugins/api";
import { UserModule } from "@/store/modules/User";

export default async function trackEvent(type: string, name: string, metaData?: any) {
    if (!UserModule.isImpersonated) {
        let query = "";
        if (metaData === null || metaData === undefined) {
            query = `mutation {
                event(type: "${type}", name: "${name}")
            }`;
        } else {
            query = `mutation {
                event(type: "${type}", name: "${name}", metaData: "${encodeURIComponent(metaData)}")
            }`;
        }
        await new Api().graphql({ query });
    }
}
